<template>
  <v-sheet :light="true">
    <base-assignment
      :available="available"
      :selected="selected"
      @save="save"
    ></base-assignment>
  </v-sheet>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"
import BaseAssignment from "@/components/BaseAssignment"
import { mapGetters } from "vuex"

export default {
  mixins: [eventMixin],
  components: {
    BaseAssignment
  },
  props: {
    userId: { type: Number }
  },
  data: function() {
    return {
      available: [],
      selected: []
    }
  },
  computed: {
    ...mapGetters("courses", ["getTemplates", "getCoursesByUserId"])
  },
  created() {
    this.selected = this.getCoursesByUserId(this.userId)
    this.available = this.getTemplates.filter(
      el => !this.selected.map(el => el.parent_id).includes(el.id)
    )
  },
  methods: {
    save({ available, selected, newAsCopy }) {
      this.overlay = false
      this.$store.dispatch("courses/assignCourses", {
        userId: this.userId,
        courseIds: selected.map(el => (el.template ? el.id : el.parent_id))
      })

      this.$emit("save", { available, selected, newAsCopy })
    }
  }
}
</script>
<style lang="scss" scoped>
div.overlay {
  min-width: 180px;
  max-width: 100%;
}
</style>
